import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import authService from "../../services/authService";
import { showToast } from "../../utils/showToast";
import "../../styles/dashboardTheme.css";

function Register() {
  const [nombreCompleto, setNombreCompleto] = useState("");
  const [email, setEmail] = useState("");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email || !username || !password || !nombreCompleto) {
      showToast({ type: "warning", message: "Todos los campos son obligatorios" });
      return;
    }

    setLoading(true);

    try {
      await authService.register({
        nombre_completo: nombreCompleto,
        email,
        username,
        password,
      });
      showToast({ type: "success", message: "Cuenta creada exitosamente" });
      setTimeout(() => navigate("/"), 1200);
    } catch (error) {
      const msg = error?.data?.message || error.message || "Error de conexión con el servidor";
      showToast({ type: "danger", message: msg });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-shell">
      <div className="auth-card">
        <div className="text-center mb-4">
          <span className="dashboard-eyebrow d-inline-block mb-1">Bienvenido</span>
          <h2 className="auth-title mb-2">Crear cuenta</h2>
          <p className="auth-subtitle">Registra tus datos para comenzar</p>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="auth-form-group">
            <label className="form-label dashboard-label">Nombre completo</label>
            <input
              type="text"
              className="form-control auth-input"
              placeholder="Nombres y apellidos"
              value={nombreCompleto}
              onChange={(e) => setNombreCompleto(e.target.value)}
              disabled={loading}
            />
          </div>

          <div className="auth-form-group">
            <label className="form-label dashboard-label">Correo electrónico</label>
            <input
              type="email"
              className="form-control auth-input"
              placeholder="correo@ejemplo.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              disabled={loading}
            />
          </div>

          <div className="auth-form-group">
            <label className="form-label dashboard-label">Usuario</label>
            <input
              type="text"
              className="form-control auth-input"
              placeholder="nombreusuario"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              disabled={loading}
            />
          </div>

          <div className="auth-form-group">
            <label className="form-label dashboard-label">Contraseña</label>
            <input
              type="password"
              className="form-control auth-input"
              placeholder="********"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              disabled={loading}
            />
          </div>

          <button type="submit" className="btn dashboard-btn-primary w-100" disabled={loading}>
            {loading ? "Creando cuenta..." : "Registrarse"}
          </button>

          <div className="auth-extra">
            <div className="auth-helper">
              ¿Ya tienes cuenta? <Link to="/" className="auth-link">Inicia sesión</Link>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}

export default Register;
